import type { StopDTO } from '@/types/dto/agent';
import { Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface LegStopProps {
  stop: StopDTO;
  day?: string | null;
  time?: string | null;
}

const LegStop: FC<LegStopProps> = ({ stop, day, time }) => {
  return (
    <div className="flex items-center justify-between tablet:items-start laptop:flex-col">
      <Typography variant="body1-bold" className="text-wrap" as="span">
        {stop.name}
      </Typography>
      <div className="flex gap-2">
        {day && (
          <Typography variant="body1" className="text-neutral">
            {day}
          </Typography>
        )}
        {time && <Typography variant="body1">{time}</Typography>}
      </div>
    </div>
  );
};

export default LegStop;
